export const SET_COUNTRIES = 'SET_COUNTRIES';
export const SET_TAGS = 'SET_TAGS';
export const SET_MACROS = 'SET_MACROS';